<mat-dialog-content scrollEnd (endReached)="scrollEndReached()">
  <h3>
    {{ 'connect_jibbie_dialog.title' | translate: {
    organizationUnitType: getOUTypeName(data.organizationUnitType) | translate,
    organizationUnitName: data.organizationUnitName
    } }}
  </h3>
  <form [formGroup]="jibbieSearch" text-center>
    <mat-form-field class="organization-name" appearance="outline">
      <mat-label>Jibbie {{ getOUTypeName(data.organizationUnitType) | translate }}</mat-label>
      <input formControlName="name" matInput>
    </mat-form-field>

    <div class="jibbie-search-results">
      @if (data.organizationUnitType === EOrganizationUnitType.LOCATION && jibbieDetails) {
        @for (jibbieLocation of (jibbieLocationResults$ | async); track jibbieLocation) {
          <mat-card appearance="outlined">
            <mat-card-header>
              <mat-icon mat-card-avatar svgIcon="doenkids-location"></mat-icon>
              <mat-card-title>{{jibbieLocation.name}} <span class="jibbie-title-suffix">({{ jibbieLocation.type }})</span></mat-card-title>
              <mat-card-subtitle>
                <strong>{{jibbieLocation.external_id}} </strong>
              </mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
              <p>
                @if (jibbieLocation.street) {
                  <span>{{jibbieLocation.street}}</span>
                  }&nbsp;
                  @if (jibbieLocation.housenumber) {
                    <span>{{jibbieLocation.housenumber}}</span>
                  }
                </p>
                <p>
                  @if (jibbieLocation.postalcode) {
                    <span>{{jibbieLocation.postalcode}}</span>
                    }&nbsp;
                    @if (jibbieLocation.city) {
                      <span>{{jibbieLocation.city}}</span>
                    }
                  </p>
                </mat-card-content>
                <mat-card-actions>
                  <button (click)="linkJibbieLocationToOrganization(jibbieLocation)" mat-button>
                    {{ 'generic.link' | translate | uppercase }}
                  </button>
                </mat-card-actions>
              </mat-card>
            }
            @if ((jibbieLocationResults$ | async)?.length === 0) {
              <span>{{ 'connnect_jibbie_dialog.no_jibbie_locations' | translate }}</span>
            }
          }
          @if (data.organizationUnitType === EOrganizationUnitType.ORGANIZATION) {
            @for (jibbieOrganisatie of (jibbieOrganisationResults$ | async); track jibbieOrganisatie) {
              <mat-card appearance="outlined">
                <mat-card-header>
                  <mat-icon mat-card-avatar svgIcon="doenkids-customer"></mat-icon>
                  <mat-card-title>{{jibbieOrganisatie.name}}</mat-card-title>
                  <mat-card-subtitle>
                    <strong>{{jibbieOrganisatie.slug}} </strong>
                  </mat-card-subtitle>
                </mat-card-header>
                <mat-card-actions>
                  <button (click)="linkJibbieOrganisationToOrganization(jibbieOrganisatie)" mat-button>
                    {{ 'generic.link' | translate | uppercase }}
                  </button>
                </mat-card-actions>
              </mat-card>
            }
            @if ((jibbieOrganisationResults$ | async)?.length === 0) {
              <span>{{ 'connect_jibbie_dialog.no_jibbie_organizations' | translate }}</span>
            }
          }
        </div>
      </form>
    </mat-dialog-content>
